function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
import "core-js/modules/web.timers.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useDrag, DndProvider } from 'react-dnd';
import { TouchBackend } from 'react-dnd-touch-backend';
import { MiniMapContainer, MiniMapColumns, MiniMapColumn, MiniMapTracker } from "./styles";
var ONE_HUNDRED_PERCENT = 1.0;
var NULL_TRACKER_VALUE = -1;
var MiniMapHandler = /*#__PURE__*/_createClass(function MiniMapHandler() {
  var _this = this;
  _classCallCheck(this, MiniMapHandler);
  this._scrollFraction = 0;
  this._visibleFraction = 0;
  this._containerWidth = 0;
  this._trackerLeftValue = 0;
  this._trackerWidth = 0;
  this.init = function (containerRef, trackerRef, parentRef) {
    if (containerRef === null || trackerRef === null || parentRef === null) return;
    _this._parent = parentRef.current;
    _this._container = containerRef.current;
    _this._tracker = trackerRef.current;
    _this._addListeners();
  };
  this.deinit = function () {
    _this._removeListeners();
  };
  this.onClick = function (e) {
    if (!_this._container) return;
    _this._setScrollFractionFromClientX(e.nativeEvent.clientX);
    _this._scrollParent({
      smooth: true,
      centerTarget: true
    });
  };
  this.onDrag = function (newLeftValue) {
    if (!_this._container) return;
    _this._setScrollFractionFromLeftValue(newLeftValue);
    _this._scrollParent({
      smooth: false,
      centerTarget: false
    });
  };
  this.getVisibleFraction = function () {
    _this._visibleFraction = _this._parent.clientWidth / _this._parent.scrollWidth;
    return _this._visibleFraction;
  };
  this.getTrackerLeftValue = function () {
    return _this._trackerLeftValue;
  };
  this.getTrackerLeftValueMax = function () {
    return _this._getMaxLeftValue();
  };
  this.getTrackerLeftValueMin = function () {
    return 0;
  };
  this.scrollParentFromTrackerPosition = function () {
    _this._parent.scrollTo();
  };
  this.updatePositionFromParentScroll = function () {
    var maxScrollLeft = _this._parent.scrollWidth * _this.getVisibleFraction();
    var newScrollFraction = _this._parent.scrollLeft / maxScrollLeft;
    _this._setScrollFraction(newScrollFraction);
    _this._setTrackerLeftValueFromScrollFraction();
  };
  this._addListeners = function () {
    _this._parent.addEventListener('scroll', _this.updatePositionFromParentScroll);
  };
  this._removeListeners = function () {
    _this._parent.removeEventListener('scroll', _this.updatePositionFromParentScroll);
  };
  this._scrollParent = function (_ref) {
    var _ref$smooth = _ref.smooth,
      smooth = _ref$smooth === void 0 ? false : _ref$smooth,
      _ref$centerTarget = _ref.centerTarget,
      centerTarget = _ref$centerTarget === void 0 ? false : _ref$centerTarget;
    var target = _this._getScrollFraction() * _this._parent.scrollWidth;
    if (centerTarget) {
      target -= _this._parent.clientWidth / 2;
    }
    if (target < 0) target = 0;
    _this._parent.scroll({
      left: target,
      behavior: smooth ? 'smooth' : 'auto'
    });
  };
  this._getContainerWidth = function () {
    return _this._container.clientWidth;
  };
  this._getTrackerWidth = function () {
    return _this._getContainerWidth() * _this.getVisibleFraction();
  };
  this._getMaxLeftValue = function () {
    return _this._getContainerWidth() - _this._getTrackerWidth();
  };
  this._getScrollFraction = function () {
    return _this._scrollFraction;
  };
  this._setScrollFractionFromLeftValue = function (pixelFromLeft) {
    var newScrollFraction = pixelFromLeft / _this._getContainerWidth();
    _this._setScrollFraction(newScrollFraction);
  };
  this._setScrollFractionFromClientX = function (clientX) {
    var _this$_container$getB = _this._container.getBoundingClientRect(),
      left = _this$_container$getB.left;
    var pixelFromLeftClicked = clientX - left;
    _this._setScrollFractionFromLeftValue(pixelFromLeftClicked);
  };
  this._setScrollFraction = function (fraction) {
    _this._scrollFraction = fraction;
  };
  this._setTrackerLeftValueFromScrollFraction = function () {
    var scrollableDistance = _this._getTrackerWidth();
    var target = _this._getScrollFraction() * scrollableDistance;
    var maxLeftValue = _this._getMaxLeftValue();
    if (target > maxLeftValue) target = maxLeftValue;else if (target < 0) target = 0;
    _this._trackerLeftValue = target;
    _this._tracker.style.left = "".concat(target, "px");
  };
} // blue window that previews page location
// element that wraps the grey columns
// element who's scroll horizontal scroll is mapped
// percent that parent is currently scrolled in decimal
// percent of parent visible without scrolling
// width in px of container from above
// tracker's distance in px from the container's left edge
// width in px of the minimap's blue tracker
// set parent and container values
// should be called in useEffect so that it's called after the first render
// if not called in useEffect, refs will be null as they have not yet rendered
// handle columns container click
// check the parent dimensions and scroll position and update the tracker position
// scrolls the targetRef element based on the current scrollFraction
// don't scroll directly to desired point or it won't be centered
/**
 * @returns width in px of grey columns container
 */
// width in px of blue window on minimap
// calculate the new scroll fraction based on where the minimap was clicked
// sets the amount that the targetRef element has scrolled in decimal (0.7 for 70%)
// scrollFraction represents the exact point desired which should be centered
// make sure to keep the tracker within the container's boundaries
);
export function Map(_ref2) {
  var _ref2$count = _ref2.count,
    count = _ref2$count === void 0 ? 8 : _ref2$count,
    onMouseDown = _ref2.onMouseDown,
    targetRef = _ref2.targetRef;
  var parentRef = useRef(null);
  var trackerRef = useRef(null);
  // the percent (as a decimal) of the scrollable area visible without scrolling
  var _useState = useState(ONE_HUNDRED_PERCENT),
    _useState2 = _slicedToArray(_useState, 2),
    visibleFraction = _useState2[0],
    setVisibleFraction = _useState2[1];
  var minimapHandler = useRef(new MiniMapHandler());
  var preDragTrackerLeftValue = useRef(NULL_TRACKER_VALUE);
  var onResize = useCallback(function () {
    setVisibleFraction(minimapHandler.current.getVisibleFraction());
  }, [minimapHandler]);
  useEffect(function () {
    // this line must be done so that the ref isn't destroyed by the time the cleanup runs
    var handler = minimapHandler.current;
    // init must be called before minimapHandler is used anywhere else
    handler.init(parentRef, trackerRef, targetRef);
    onResize();
    window.addEventListener('resize', onResize);
    return function () {
      handler.deinit();
      window.removeEventListener('resize', onResize);
    };
  }, [onResize, minimapHandler, parentRef, trackerRef, targetRef]);

  // As the size of the target ref might change we refresh it every second.
  useEffect(function () {
    var interval = setInterval(function () {
      onResize();
    }, 1000);
    return function () {
      return clearInterval(interval);
    };
  }, []);
  var onClick = function onClick(e) {
    // if not NULL_TRACKER_VALUE aka -1, this was a drag, not a click.
    // this onClick happens after onDrag's end method
    if (preDragTrackerLeftValue.current !== NULL_TRACKER_VALUE) {
      preDragTrackerLeftValue.current = NULL_TRACKER_VALUE;
      return;
    }
    minimapHandler.current.onClick(e);
  };
  var _useDrag = useDrag({
      item: {
        type: 'minimap'
      },
      collect: function collect(monitor) {
        if (!monitor.isDragging()) return;
        var distanceDragged = monitor.getDifferenceFromInitialOffset();
        if (distanceDragged === null) return;
        var newLeftValue = preDragTrackerLeftValue.current + distanceDragged.x;
        var currentLeft = minimapHandler.current.getTrackerLeftValue();
        var maxLeft = minimapHandler.current.getTrackerLeftValueMax();
        var minLeft = minimapHandler.current.getTrackerLeftValueMin();
        if (newLeftValue > maxLeft && currentLeft === maxLeft) return;
        if (newLeftValue < minLeft && currentLeft === minLeft) return;
        minimapHandler.current.onDrag(newLeftValue);
      },
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      begin: function begin(_) {
        preDragTrackerLeftValue.current = minimapHandler.current.getTrackerLeftValue();
        return {
          type: 'minimap'
        };
      }
    }),
    _useDrag2 = _slicedToArray(_useDrag, 2),
    dragRef = _useDrag2[1];
  return /*#__PURE__*/React.createElement(MiniMapContainer, {
    ref: dragRef,
    visible: (targetRef === null || targetRef === void 0 ? void 0 : targetRef.current) && visibleFraction !== 1.0,
    id: "mini-map",
    onMouseDown: onMouseDown
  }, /*#__PURE__*/React.createElement(MiniMapColumns, {
    onClick: onClick,
    forwardRef: parentRef
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'inline-flex'
    }
  }, _toConsumableArray(Array(count)).map(function (_, i) {
    return /*#__PURE__*/React.createElement(MiniMapColumn, {
      key: "minimap_".concat(i),
      "aria-label": "column-".concat(i)
    });
  })), /*#__PURE__*/React.createElement(MiniMapTracker, {
    ref: trackerRef,
    width: visibleFraction * 100
  })));
}
export var MiniMap = function MiniMap(props) {
  return /*#__PURE__*/React.createElement(DndProvider, {
    backend: TouchBackend,
    options: {
      enableMouseEvents: true
    }
  }, /*#__PURE__*/React.createElement(Map, props));
};